import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AddUserComponent } from '../../popups/add-user/add-user.component';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { IEmployee } from '../../shared/classes/IEmployee';
import { DataService } from '../../shared/services/data.service';
import { FormsModule } from '@angular/forms';
import { NgClass } from '@angular/common';
import { MatProgressSpinner } from '@angular/material/progress-spinner';
import { NgxPaginationModule } from 'ngx-pagination';

@Component({
    selector: 'app-users',
    templateUrl: './users.component.html',
    styleUrls: ['./users.component.scss'],
    standalone: true,
    imports: [FormsModule, NgClass, MatProgressSpinner, NgxPaginationModule]
})
export class UsersComponent implements OnInit {
    page = 1;
    employeeList: IEmployee[] = [];
    employeeFilteredList: IEmployee[] = [];
    site: string;

    public sortFilter = '';
    public roleFilter = 'All';
    public siteFilter = 'All';
    public searchFilter: string;
    sortAscending: boolean;

    public listLoaded = false;

    constructor(
        private dialog: MatDialog,
        private dataService: DataService,
        private router: Router
    ) {}

    async ngOnInit() {
        if (!(await this.dataService.isCurrentUserAnAdmin())) {
            this.router.navigateByUrl('/no-access');
        }
        await this.refresh();
        this.filterUserList();
    }

    async refresh(): Promise<void> {
        const employees = await this.dataService.getEmployees();
        if (employees) {
            this.employeeList = Object.values(employees).filter((employee) => !!employee.user);
        }

        this.site = this.dataService.getSite();
        this.listLoaded = !!employees;
    }

    public addEmployee(): void {
        const dialogConfig = new MatDialogConfig();
        dialogConfig.disableClose = true;
        dialogConfig.autoFocus = true;
        this.dialog.open(AddUserComponent, dialogConfig);
    }

    public filterUserList(): void {
        if (this.employeeList.length === 0) {
            this.refresh();
        }
        this.employeeFilteredList = this.employeeList.slice().filter((item) => {
            if (
                this.searchFilter &&
                !(
                    item.user.firstName.toUpperCase().includes(this.searchFilter.toUpperCase()) ||
                    item.user.surName.toUpperCase().includes(this.searchFilter.toUpperCase()) ||
                    item.gid.toUpperCase().includes(this.searchFilter.toUpperCase())
                )
            ) {
                return false;
            }

            if (item.role !== this.roleFilter && this.roleFilter !== 'All') {
                return false;
            }

            if (item.site !== this.siteFilter && this.siteFilter !== 'All') {
                return false;
            }
            // if ((order.justDocuments && this.typeFilter === 'Standard') || (!order.justDocuments && this.typeFilter === 'Non-Standard')) {
            //   return false;
            // }
            // if (this.smnFilter && !order.SMN.toUpperCase().includes(this.smnFilter.toUpperCase())) {
            //   return false;
            // }
            // if (this.idFilter && !order.inspectorID.toUpperCase().includes(this.idFilter.toUpperCase())) {
            //   return false;
            // }
            // if (this.poFilter && (order.justDocuments || !order.getPO(this.site).toUpperCase().includes(this.poFilter.toUpperCase()))) {
            //   return false;
            // }

            return true;
        });

        this.sortUserList('surName');
    }

    public sortUserList(filter: string): void {
        this.sortAscending = !this.sortAscending;
        this.sortFilter = filter;
        this.employeeFilteredList = this.employeeFilteredList.sort((a: IEmployee, b: IEmployee) => {
            let val: number;
            switch (this.sortFilter) {
                case 'surName':
                    val = a.user.surName.localeCompare(b.user.surName);
                    break;
                case 'gid':
                    val = a.gid.localeCompare(b.gid);
                    break;
                case 'role':
                    val = a.role.localeCompare(b.role);
                    break;
                case 'site':
                    val = a.site.localeCompare(b.site);
                    break;
            }
            return this.sortAscending ? val : -val;
        });
    }
}
